/**
 * 验证码组件专用 axios 实例
 * 注意：不能复用项目的 request.js，因为响应拦截器会破坏 captcha 的 repCode/repData 格式
 */
import axios from "axios";
import Config from "@/config/index.js";
import { isAndroid } from "@/utils/isTerminal.js";

var service = axios.create({
  baseURL: Config.apiUrl,
  timeout: 120000,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json; charset=UTF-8",
  },
});

service.interceptors.request.use(
  function(config) {
    config.headers["businessSource"] = 1;
    config.headers["terminalPlatform"] = isAndroid ? 3 : 2;
    config.headers["requestId"] = new Date().getTime();
    return config;
  },
  function(error) {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  function(response) {
    return response.data;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default service;
